"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorTwister = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../");
const select_1 = require("../../select");
const SelectorTwister = ({ dimensionKeyIndex, displayString, dimensionValues, variationState, variationMap, handleOnClick }) => (react_1.default.createElement("div", { style: { margin: '5px 0px' }, key: dimensionKeyIndex },
    react_1.default.createElement(select_1.SingleSelector, { ariaLabel: displayString, options: dimensionValues[dimensionKeyIndex].map((value, dimensionValueIndex) => {
            const variationValues = [...variationState];
            variationValues[dimensionKeyIndex] = dimensionValueIndex;
            const asin = (0, __1.getAsinFromVariation)(variationMap, variationValues);
            return { label: value, value: dimensionValueIndex.toString(), isNotValid: !asin };
        }), defaultOption: {
            label: dimensionValues[dimensionKeyIndex][variationState[dimensionKeyIndex]],
            value: variationState[dimensionKeyIndex] ? variationState[dimensionKeyIndex].toString() : '0'
        }, dataCyPrefix: "twister-selector", size: "large", onChangeHook: (option) => handleOnClick(dimensionKeyIndex, parseInt(option.value)) })));
exports.SelectorTwister = SelectorTwister;
